import React, { useState } from "react";
import DataGrid, {
  Column,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Selection,
  Scrolling,
  Button,
  ColumnFixing,
} from "devextreme-react/data-grid";
import Guid from "devextreme/core/guid";
import { api_path } from "../../shared.js";
import { createStore } from "devextreme-aspnet-data-nojquery";
import swal from "sweetalert";
import axios from "axios";
import Box from "@mui/material/Box";
import { Tooltip, IconButton } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
export default function TodoListComponent({ userId }) {
  const [getLoadGrid, setLoadGrid] = useState();
  const url = `${api_path}/customer/get-reminder.php?userId=${userId}&load=${getLoadGrid}`;

  const dataSource = createStore({
    key: "SALES_ACTIVITY_ID",
    loadUrl: url,
  });

  const cellPrepared = (e) => {
    if (e.rowType === "data") {
      const cusCode = e.data.CRM_CUSCODE; // เอา id จาก field crm_cuscode
      if (e.column.dataField === "ACTIVITY_NAME") {
        e.cellElement.innerHTML =
          "<span class='status-button badge  activity-" +
          e.data.ACTIVITY_NAME.toLowerCase().replace(/\s/g, "-") +
          "'><a href='Customer?customer_id=" +
          cusCode +
          "'  title='View' target='_blank' style='color: #FFFFFF;'>" +
          e.data.ACTIVITY_NAME +
          "</a></span>";
      }
      if (e.column.dataField === "CUSTOMER_NAME") {
        e.cellElement.innerHTML =
          "<span class='link2'><a href='Customer?customer_id=" +
          cusCode +
          "'  title='View' target='_blank''>" +
          e.data.CUSTOMER_NAME +
          "</a></span>";
      }
      if (e.column.dataField === "TOPIC") {
        e.cellElement.innerHTML =
          "<span class='link2'><a href='Customer?customer_id=" +
          cusCode +
          "'  title='View' target='_blank''>" +
          e.data.TOPIC +
          "</a></span>";
      }
    }
  };
  const onDeleteButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    swal({
      title: "Are you sure to delete this task ?",
      text: "",
      icon: "info",
      dangerMode: false,
      buttons: true,
    }).then((isConfirm) => {
      if (isConfirm) {
        delTask(e.row.key);
      }
    });
  }, []);
  const delTask = async (id) => {
    try {
      const token = process.env.REACT_APP_API_TOKEN;
      const response = await axios.delete(
        `${api_path}/customer/customer_activities_item.php?id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setLoadGrid(randomNumberInRange(1, 20));
    } catch (error) {
      console.error(error);
    }
  };
  const randomNumberInRange = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  return (
    <div className="p-4 bg-white shadow rounded-2xl">
      <h5 className="font-semibold mb-2">
        🔔 Reminder
        <Tooltip
          title="งานที่จะถึงใน 3 วันข้างหน้าหรือเลยวันไปแล้วแต่ยังไม่ถูกลบ"
          arrow
        >
          <IconButton size="small">
            <HelpOutlineIcon fontSize="small" color="action" />
          </IconButton>
        </Tooltip>
      </h5>
      <Box sx={{ maxHeight: 300, overflow: "auto" }}>
        <DataGrid
          onCellPrepared={cellPrepared}
          dataSource={dataSource}
          showBorders={true}
          columnAutoWidth={true}
          rowAlternationEnabled={true}
          showScrollbar={true}
          keyExpr="CRM_CUSCODE"
          showColumnHeaders={true}
          height={500}
        >
          <Scrolling
            rowRenderingMode="virtual"
            showScrollbar="always"
            useNative="false"
            scrollByThumb="true"
          ></Scrolling>
          <ColumnFixing enabled={true} />
          <FilterRow visible={true} />
          <FilterPanel visible={false} />
          <HeaderFilter visible={true} />
          <Selection mode="single" />
          <Column dataField="CRM_CUSCODE" visible={false} />
          <Column dataField="TOPIC" caption="Topic" />
          <Column dataField="CUSTOMER_NAME" caption="Customer" />
          <Column dataField="ACTIVITY_NAME" caption="Activity" />

          <Column
            dataField="REMINDER"
            caption="Date"
            dataType="date" // ให้เป็น date (หรือ 'datetime' ถ้าต้องการเวลา)
            format="dd-MMM-yyyy HH:mm"
            groupInterval="day" // สำคัญ: บอกให้ HeaderFilter รู้ว่าจะจัดกลุ่มเป็นวัน
          >
            <HeaderFilter allowSearch={true} />
          </Column>
          <Column type="buttons" caption="" fixed={true} width={30}>
            <Button icon="trash" onClick={onDeleteButtonClick} hint="Delete" />
          </Column>
        </DataGrid>
      </Box>
    </div>
  );
}
